import { render, staticRenderFns } from "./profile.component.vue?vue&type=template&id=104c2179&scoped=true&"
import script from "./profile.component.vue?vue&type=script&lang=ts&"
export * from "./profile.component.vue?vue&type=script&lang=ts&"
import style0 from "./profile.component.vue?vue&type=style&index=0&id=104c2179&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104c2179",
  null
  
)

export default component.exports